import React from 'react'

function Booktable() {
  return (
    <div>
                          <div id="book-a-table" className="bg-white rounded shadow-sm p-4 mb-5 rating-review-select-page">
                    <h5 className="mb-4">Book A Table</h5>
                    <form>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Full Name</label>
                            <input className="form-control" type="text" placeholder="Enter Full Name" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Email Address</label>
                            <input className="form-control" type="text" placeholder="Enter Email address" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Mobile number</label>
                            <input className="form-control" type="text" placeholder="Enter Mobile number" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Date And Time</label>
                            <input className="form-control" type="text" placeholder="Enter Date And Time" />
                          </div>
                        </div>
                      </div>
                      <div className="form-group text-right">
                        <button className="btn btn-primary" type="button"> Submit </button>
                      </div>
                    </form>
                  </div>
    </div>
  )
}

export default Booktable